'use strict';

/** @type {import('./round')} */
module.exports = Math.round;



//////////////////
// WEBPACK FOOTER
// ../~/math-intrinsics/round.js
// module id = 953
// module chunks = 0